<template>
  <div class="ItemComponentForm">
    <!-- <div data-v-fae5bece class="v-card__title headline lighten-2 v-card__title--primary">Zaposleni</div> -->

    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
      style="padding-left: 16px; padding-bottom: 0px; padding-top: 0px"
    >
      <div>Zaposleni</div>

      <button
        id="closeModalBtn"
        @click.prevent="closeModalInModal_izbor_redova"
        class="v-btn v-btn--flat white"

        v-if="operationType !== undefined && operationType !== null"
      >
        <v-icon>close</v-icon>
      </button>
    </div>

    <div data-v-fae5bece class="spacer"></div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <!--<v-layout row wrap>-->
      <!--<v-flex xs8>-->
      <!--<v-text-field-->
      <!--v-model="ID"-->
      <!--label="ID" readonly-->
      <!--&gt;</v-text-field>-->
      <!--</v-flex>-->
      <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->

      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="ime"
            label="Ime"
            :rules="[v => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="prezime"
            label="Prezime"
            :rules="[v => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="sifra"
            label="JMBG"
            
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Datum rođenja"
              readonly
              @blur="date = parseDate(dateFormatted)"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="drzava"
            label="Država"
            
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="grad"
            label="Mesto"
            
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Name -->

      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="adresa"
            label="Adresa"
            
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="fiksni"
            label="Fiksni tel."
            
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="mobilni"
            label="Mobilni tel."
            
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="email"
            label="Email"
            
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="pozicija"
            label="Pozicija"
            
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menuZaposlenje"
            v-model="menuZaposlenje"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormattedZaposlenje"
              label="Zaposlenje"
              readonly
              @blur="dateZaposlenje = parseDate(dateFormattedZaposlenje)"
            ></v-text-field>
            <v-date-picker
              v-model="dateZaposlenje"
              no-title
              @input="menuZaposlenje = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->
      <v-layout row wrap>
        <v-flex xs2 pa-2>
           <v-text-field
            v-model="tip_zaposlenja"
            label="Tip zaposlenja"
            
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled">Sačuvaj</v-btn>
          <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken"/>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "employeeItem",
  components: {
      TokenComponent
    },
  data: () => ({
    valid: true,
    ID: "0",
    ime: "",
    naziv_pomocni: "",
    prezime_pomocni: "",
    adresa: "",
    fiksni: "",
    mobilni: "",
    email: "",
    pozicija: "",
    prezime: "",
    drzava: "",
    grad: "",
    sifra: "",
    max: 2,
    selected_flasiranje: false,
    selected_ulaz_grozdja: false,
    menu: "",
    date: undefined,
    dateFormatted: null,
    menuZaposlenje: "",
    dateFormattedZaposlenje: null,
    dateZaposlenje: undefined,
    tip_zaposlenja: ""
  }),

  methods: {
    closeModalInModal_izbor_redova(){
      let complex;

      complex = {
        name: this.naziv_pomocni,
        lastname: this.prezime_pomocni
      };

      this.$emit("close", complex);
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
      this.dateZaposlenje = [Year, Month, Day].join("-");
    },
    newSifarnik() {
      this.naziv_pomocni = this.ime;
      this.prezime_pomocni = this.prezime;

      var complexObject = {
        firstName: this.ime,
        lastName: this.prezime,
        identityNumber: this.sifra,
        dateOfBirth: this.date !== undefined ? this.date + "T00:00:00.000" : null,
        country: this.drzava,
        city: this.grad,
        address: this.adresa,
        phone: this.fiksni,
        mobile: this.mobilni,
        email: this.email,
        workingPosition: this.pozicija,
        dateOfEmploying: this.dateZaposlenje !== undefined ? this.dateZaposlenje + "T00:00:00.000" : null,
        workingType: this.tip_zaposlenja
      };

      console.log(complexObject);

      this.$http
        .post(this.globalServiceLocation + this.globalPort + "/employee/create", complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          if(this.operationType !== undefined && this.operationType !== null)
            this.closeModalInModal_izbor_redova();
          else
            serverBus.$emit("refresh_employee");
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .post(this.globalServiceLocation + this.globalPort + "/employee/create", complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          if(this.operationType !== undefined && this.operationType !== null)
            this.closeModalInModal_izbor_redova();
          else
            serverBus.$emit("refresh_employee");
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    changeSifarnik() {
      var complexObject = {
        id: this.ID,
        firstName: this.ime,
        lastName: this.prezime,
        identityNumber: this.sifra,
        dateOfBirth: this.date !== undefined ? this.date + "T00:00:00.000" : null,
        country: this.drzava,
        city: this.grad,
        address: this.adresa,
        phone: this.fiksni,
        mobile: this.mobilni,
        email: this.email,
        workingPosition: this.pozicija,
        dateOfEmploying: this.dateZaposlenje !== undefined ? this.dateZaposlenje + "T00:00:00.000" : null,
        workingType: this.tip_zaposlenja
      };

      

      this.$http
        .put(
          this.globalServiceLocation + this.globalPort + "/employee/update",
          complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
          serverBus.$emit("refresh_employee");
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .put(
          this.globalServiceLocation + this.globalPort + "/employee/update",
          complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
          serverBus.$emit("refresh_employee");
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID != "" && this.ID != "0") {
          this.changeSifarnik();
        } else {
          this.newSifarnik();
        }

        
        this.clear();
      }
    },
    clear() {
      this.$refs.form.reset();
      this.ID = 0;

      this.selected_flasiranje = false;
      this.selected_ulaz_grozdja = false;

      // this.setDate();
      this.date = undefined;
      this.dateZaposlenje = undefined;
    }
  },
  mounted() {
    this.clear();

    serverBus.$on("applied_employee", item => {
      // // console.log(item);

      this.ID = item.id;
      this.ime = item.firstName;
      this.prezime = item.lastName;
      this.sifra = item.identityNumber;
      this.adresa = item.address;
      this.grad = item.city;
      this.drzava = item.country;
      this.email = item.email;
      this.mobilni = item.mobile;
      this.fiksni = item.phone;
      this.pozicija = item.workingPosition;
      this.tip_zaposlenja = item.workingType;

      if (item.dateOfBirth !== null && typeof item.dateOfBirth !== "undefined")
        this.date = item.dateOfBirth.split('T')[0];
      
      if (item.dateOfEmploying !== null && typeof item.dateOfEmploying !== "undefined")
        this.dateZaposlenje = item.dateOfEmploying.split('T')[0]; 
    });
  },
  props: [
    "operationType"
  ],
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
    dateZaposlenje(val) {
      this.dateFormattedZaposlenje = this.formatDate1(this.dateZaposlenje);
    },
    operationType: function (val) {
      

      if(val !== null && val !== undefined)
        this.operation_to_select = val;
    }
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  }
};
</script>
    
<style lang="scss" scoped>
// .phaseItemComponentForm {
//   max-width: 430px;
// }

@import "./../assets/sass/parts/modalStyles";

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
